import { ROUTER } from '@core/constants/router.constants';
import { LoginPage } from '@modules/authentication/pages/login';
import { RouteObject } from 'react-router-dom';

export const authenticationRouter: RouteObject = {
  path: ROUTER.AUTHENTICATION.LOGIN,
  Component: LoginPage,
};
